module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.6.3-125.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.6.3.md
// module id = 543
// module chunks = 259